import React from 'react';

function Navbar(){
    return(
        <nav className='bg-bgDark py-4'>
            <h1 className='text-3xl font-bold text-center text-white'>Top Courses</h1>
        </nav>
    );

}
export default Navbar;